import { render } from "./addPhotoIcon.vue?vue&type=template&id=72043d05"
import script from "./addPhotoIcon.vue?vue&type=script&lang=js"
export * from "./addPhotoIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__